/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import "@polymer/iron-icon/iron-icon.js";
import "@polymer/iron-icons/iron-icons.js";
import template from "./ns-search.html";
import NsDropdown from "@nuskin/ns-form-elements";
import "../ns-iron-solr-query/ns-iron-solr-query.js";
import { events } from "@nuskin/ns-util";

export class NsSearch extends PolymerElement {
  constructor() {
    super();
  }

  ready() {
    super.ready();
    this.isLoaded = false;
    this.$.queryText.value = "";
    this.search();
    if (window.location.hash) {
      let hash = window.location.hash;
      this.queryParamProfileId = hash.slice(1);
      console.log("window location hash + slice ", this.queryParamProfileId);
      this._runSingleSearch = true;
    }
  }

  static get is() {
    return "ns-search";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      selectText: {
        type: String,
        value: "Select"
      },
      searchText: {
        type: String,
        value: "Search"
      },
      filterDisplayArray: {
        type: Array,
        computed: "_getFilterDisplayArray(filterArray)"
      },
      filterArray: {
        type: Array,
        value: [
          ["Any", ""],
          ["Distributor ID", "external_id"],
          ["Business Name", "name_business"],
          ["English Name", "name_en"],
          ["Local Name", "name_local"],
          ["Country", "country"],
          ["Title", "titles"]
        ],
        observer: "_filterArrayChanged"
      },
      selectedIndex: {
        type: Array,
        observer: "_updateSelectedField"
      },
      selectedFilter: String,
      responseData: {
        type: Array,
        observer: "_handleResponse"
      },
      responseDataConverted: {
        type: Array,
        notify: true
      },
      queryParamProfileId: {
        type: String,
        value: ""
      },
      singleProfile: {
        type: Object,
        value: {},
        notify: true
      },
      host: {
        type: String,
        value: "https://devgw.mynuskin.com/mec/solr"
      },
      countryCodeTranslationMap: {
        type: Array,
        value: []
      },
      _isSingleSearchData: {
        type: Boolean,
        value: false
      },
      _runSingleSearch: {
        type: Boolean,
        value: false
      },
      _debug: {
        type: Boolean,
        value: false
      },
      clientid: String,
      clientsecret: String,
      badgeColorMap: {
        type: Array,
        value: []
      },
      _dropdownMinWidth: {
        type: Number,
        value: 175,
        readyOnly: true
      },
      badgeTranslationMap: {
        type: Array,
        value: [{}]
      },
      gotAllData: {
        type: Boolean,
        notify: true
      },
      pagination: {
        type: Number,
        value: 0,
        notify: true
      },
      currentlySearching: {
        type: String,
        value: "false",
        notify: true
      }
    };
  }

  _filterArrayChanged(newVal, oldVal) {
    console.log("filterArray: ", newVal);
    if (newVal) {
      this.set("filterArray", newVal);
    }
  }

  _getFilterDisplayArray(filter) {
    let displayTitles = [];
    for (let i = 0; i < filter.length; i++) {
      displayTitles.push(filter[i][0]);
    }
    return displayTitles;
  }

  _loadQueryProfile() {
    this._singleSearch = true;
    this.selectedFilter = "external_id";
    this.$.queryText.value = this.queryParamProfileId;
    this.search();
  }

  _updateSelectedField() {
    //Set Query Filter
    let filterText = "";
    if (this.selectedIndex && this.selectedIndex[0] > 0) {
      filterText = this.filterArray[this.selectedIndex[0]][1];
    }
    this.selectedFilter = filterText;
  }

  _handleResponse() {
    let personObjects = [];
    let rawData = this.responseData;
    if (rawData.length === 0) {
      this.gotAllData = true;
    }
    for (let i = 0; i < rawData.length; i++) {
      let newPersonObj = {};
      let rawPerson = rawData[i];
      if (rawPerson.name_en) {
        newPersonObj.englishName = rawPerson.name_en;
      }

      newPersonObj.distributorId = rawPerson.external_id
        ? rawPerson.external_id
        : "";
      newPersonObj.nativeName = rawPerson.name_local
        ? rawPerson.name_local
        : "";
      newPersonObj.businessName = rawPerson.name_business
        ? rawPerson.name_business
        : "";
      newPersonObj.profilePhoto =
        "/content/dam/Recognition/App/Profile/" +
        rawPerson.external_id +
        ".jpg";

      if (rawPerson.country) {
        // var countryName = this.countryCodeTranslations[rawPerson.country];
        // if(countryName) {
        //     newPersonObj.country = countryName;
        // } else {
        //     newPersonObj.country = '';
        // }
        newPersonObj.country = rawPerson.country;
      } else {
        newPersonObj.country = "";
      }

      newPersonObj.country = rawPerson.country
        ? this._getCountryDisplay(rawPerson.country)
        : "";

      newPersonObj.photos = [];
      if (rawPerson.photos) {
        newPersonObj.photos = rawPerson.photos;
      }

      newPersonObj.videos = [];
      if (rawPerson.videos) {
        newPersonObj.videos = rawPerson.videos;
      }

      newPersonObj.badges = [];
      if (rawPerson.titles) {
        for (let j = 0; j < rawPerson.titles.length; j++) {
          let rawTitle = rawPerson.titles[j];
          let titleObj = {};

          let title = this._getBadgeDisplay(rawTitle);

          titleObj.years = /(\d*)\sYear/i.test(title)
            ? title.match(/(\d*)\sYear/i)[1]
            : null;
          titleObj.stars = /(\d*)\sStar/i.test(title)
            ? title.match(/(\d*)\sStar/i)[1]
            : null;
          titleObj.circle_num = /(\d*)\sMillion/i.test(title)
            ? title.match(/(\d*)\sMillion/i)[1]
            : null;
          titleObj.title_text = title
            .replace(/(\d*\s(Year|Star))/i, "")
            .replace(/(\d*\s)Million/i, "MILLION")
            .trim();
          titleObj.color = this._setBadgeColor(rawTitle);
          newPersonObj.badges.push(titleObj);
        }
      }

      personObjects.push(newPersonObj);
    }

    if (!this._singleSearch) {
      this.responseDataConverted = this.responseDataConverted.concat(
        personObjects
      );
      //                    this.responseDataConverted = personObjects;
      console.log("Search Data:", this.responseDataConverted);
      if (this._runSingleSearch) {
        this._runSingleSearch = false;
        this._loadQueryProfile();
      }
    } else {
      this.singleProfile = personObjects[0];
      this._singleSearch = false;
      console.log("Single Profile:", this.singleProfile);
    }
  }

  _getBadgeDisplay(title) {
    for (let i = 0; i < this.badgeTranslationMap.length; i++) {
      let titleCode = title.slice(-3);
      if (
        this.badgeTranslationMap[i].code.toLocaleUpperCase() ===
        titleCode.toLocaleUpperCase()
      ) {
        let badgeYears = title.slice(0, -3).trim();
        badgeYears = badgeYears !== "" ? badgeYears : 0;
        // TODO This will need more robust logic in to determine stars/years in the future.
        return badgeYears + " Year " + this.badgeTranslationMap[i].displayText;
      }
    }
    return title;
  }

  _getCountryDisplay(country) {
    for (let i = 0; i < this.countryCodeTranslationMap.length; i++) {
      if (
        this.countryCodeTranslationMap[i].code.toLocaleUpperCase() ===
        country.toLocaleUpperCase()
      ) {
        return this.countryCodeTranslationMap[i].displayText;
      }
    }
    return country;
  }

  /**
   * Determines the color to use for a badge based on the its title. It is compared against the color map
   * that is defined in the dialog configuration for the component.
   * @param title_code The title of the badge
   * @returns {string} The hexadecimal value of a color that corresponds to the
   * @private
   */
  _setBadgeColor(title_code) {
    let color = "#60AB98";

    for (let i = 0; i < this.badgeColorMap.length; i++) {
      if (
        title_code
          .toLocaleUpperCase()
          .indexOf(this.badgeColorMap[i].title.toLocaleUpperCase()) > -1
      ) {
        color = this.badgeColorMap[i].color;
        break;
      }
    }

    if (color.indexOf("#") === -1) {
      color = "#" + color;
    }

    return color;
  }

  search() {
    this.pagination = 0;
    this.gotAllData = false;
    this.set("responseDataConverted", []);
    //Set Query Term
    let queryElement = this.$.queryText;
    let queryInput = queryElement.value.trim();
    //Submit Query
    this.$.solrsearch.query(queryInput);
    if (this.isLoaded) {
      events.publish(events.recognition.RECOGNITION_SEARCH, {
        recognition: { searchTerm: queryInput }
      });
    }
    this.isLoaded = true;
  }

  checkEnter(e) {
    if (e.key === "Enter") {
      this.search();
    }
  }
}

customElements.define(NsSearch.is, NsSearch);
